import moment from 'moment'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { CalendarEvent } from 'paintscout'
import { ProjectsByDay } from './ProjectsByDay'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  }
}))

export default function MobileWeekView(props) {
  const { events, date }: { events: CalendarEvent[]; date: Date } = props

  const classes = useStyles()

  function getStartAndEndOfWeek(date) {
    const startOfWeek = moment(date).startOf('week').toDate()
    const endOfWeek = moment(date).endOf('week').toDate()
    return { startOfWeek, endOfWeek }
  }

  function filterEventsForWeek(events, startOfWeek, endOfWeek) {
    return events.filter((event) => {
      const eventStart = new Date(event.start)
      const eventEnd = new Date(event.end)

      // Check if the event overlaps with the current week
      return eventStart <= endOfWeek && eventEnd >= startOfWeek
    })
  }

  function getDaysOfTheWeek(startOfWeek): Date[] {
    const daysOfTheWeek = []
    for (let i = 0; i < 7; i++) {
      daysOfTheWeek.push(moment(startOfWeek).add(i, 'days').toDate())
    }
    return daysOfTheWeek
  }

  function filterEventsForDay(events, day) {
    return events.filter((event) => {
      const eventStart = new Date(event.start)
      const eventEnd = new Date(event.end)
      return (
        (eventStart <= day && eventEnd >= day) ||
        eventStart.toDateString() === day.toDateString() ||
        eventEnd.toDateString() === day.toDateString()
      )
    })
  }

  const { startOfWeek, endOfWeek } = getStartAndEndOfWeek(date)
  const filteredEvents = filterEventsForWeek(events, startOfWeek, endOfWeek)
  const daysOfTheWeek = getDaysOfTheWeek(startOfWeek)

  return (
    <div className={classes.root}>
      {daysOfTheWeek.map((day) => (
        <ProjectsByDay key={day.toDateString()} day={day} events={filterEventsForDay(filteredEvents, day)} />
      ))}
    </div>
  )
}

MobileWeekView.title = (date: Date) => {
  const start = moment(date).clone().startOf('week')
  const end = moment(date).clone().endOf('week')
  if (start.month() === end.month()) {
    return `${start.format('MMMM DD')} – ${end.format('DD')}`
  }
  return `${start.format('MMMM DD')} – ${end.format('MMMM DD')}`
}

MobileWeekView.navigate = (date: Date, action: string) => {
  switch (action) {
    case 'PREV':
      return moment(date).subtract(1, 'week').toDate()
    case 'NEXT':
      return moment(date).add(1, 'week').toDate()
    default:
      return date
  }
}
